<template>
  <div>
    <v-dialog
      v-model="dialogShow"
      fullscreen
      :style="{ zIndex: formDialogOptions.zIndex }"
      @keydown.esc.prevent="closeForm"
      persistent
      :hide-overlay="$vuetify.breakpoint.smAndDown"
    >

      <v-card>
        <v-form v-model="valid" ref="form">
          <v-toolbar dark color="brown" class="color-gradient-1" dense>
            <v-btn icon dark @click="closeForm">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-toolbar-title>Buku, Jurnal, Produk Hukum etc</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                dark
                text
                @click="save"
                :disabled="!valid || isItemModified === false"
                class="hidden-md-and-up"
              >
                Simpan
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-title class="text-uppercase grey--text">
            <span v-if="formMode === 'EDIT_FORM'">EDIT </span>
            <span class="font-weight-light ml-1 mr-1">ITEM</span>
            <span v-if="formMode === 'NEW_FORM'"> BARU</span>
            <v-chip
              class="ma-2"
              color="warning"
              outlined
              x-small
              v-show="isItemModified"
            >
              <v-icon left> mdi-pencil </v-icon>
              modfied
            </v-chip>
          </v-card-title>

          <v-card-text>
            <v-container class="pa-2 text-center">
              <v-row>
                <v-col cols="12" md="3" sm="5">
                  <v-container class="pa-2 text-center">
                    <v-row class="fill-height" align="center">
                      <v-hover v-slot="{ hover }">
                        <v-card
                          class="align-self-center"
                          :elevation="hover ? 10 : 1"
                          :class="[
                            { 'on-hover': hover },
                            hover
                              ? 'card-hover-opacity'
                              : 'card-not-hover-opacity',
                          ]"
                        >
                          <v-img
                            :lazy-src="lookupImageUrlLazy(itemModified)"
                            :src="lookupImageUrl(itemModified)"
                            height="250px"
                            width="250px"
                            contain
                          >
                            <v-card-title
                              class="text-h6 white--text fill-height"
                            >
                              <v-row
                                class="fill-height flex-column"
                                justify="space-between"
                              >
                                <v-spacer />
                                <div class="align-self-center">
                                  <v-btn
                                    :class="{ 'show-btns': hover }"
                                    :color="transparent"
                                    icon
                                    large
                                    dark
                                    outlined
                                    @click="showDialogUpload"
                                  >
                                    <v-icon
                                      :class="{ 'show-btns': hover }"
                                      :color="transparent"
                                      large
                                    >
                                      mdi-upload
                                    </v-icon>
                                  </v-btn>
                                </div>
                              </v-row>
                            </v-card-title>
                          </v-img>
                        </v-card>
                      </v-hover>
                    </v-row>
                  </v-container>
                </v-col>
                <v-col cols="12" md="9" sm="7">
                  <v-row>
                    <v-col cols="12" sm="4" md="3">
                      <v-text-field
                        v-model="itemModified.kode1"
                        :rules="rulesLenght"
                        label="Kode1"
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="itemModified.description"
                        label="Judul Jurnal/Artikel"
                        :rules="rulesNotEmtpy"
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="4" md="4">
                      <v-autocomplete
                        v-model="itemModified.fdivisionBean"
                        :items="itemsFDivision"
                        :rules="rulesNotEmtpy"
                        item-value="id"
                        item-text="description"
                        auto-select-first
                        dense
                        chips
                        deletable-chips
                        color="blue-grey lighten-2"
                        label="Divisi/Bidang"
                        hint="Divisi/Bidang"
                        persistent-hint
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <v-autocomplete
                        v-model="itemModified.farticleCategBean"
                        :items="itemsFArticleCateg"
                        :rules="rulesNotEmtpy"
                        item-value="id"
                        item-text="description"
                        auto-select-first
                        dense
                        chips
                        deletable-chips
                        color="blue-grey lighten-2"
                        label="Kategori Jurnal/Artikel"
                        hint="Kategori Jurnal/Artikel"
                        persistent-hint
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="itemModified.publisher"
                        label="Publisher"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-menu
                        v-model="menuDate"
                        :close-on-content-click="false"
                        max-width="290"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :value="
                              computedDateFormattedDatefns(
                                itemModified.publicationDate
                              )
                            "
                            prepend-inner-icon="mdi-calendar"
                            clearable
                            label="Tanggal Publikasi"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            @click:clear="itemModified.publicationDate = null"
                          ></v-text-field>
                        </template>

                        <v-date-picker
                          v-model="publicationDate"
                          @change="menuDate = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>

            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field
                    v-model="itemModified.volume"
                    label="Volume"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field
                    v-model="itemModified.pages"
                    label="Halaman"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="itemModified.issues"
                    label="Issues"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                      v-model="itemModified.doi"
                      label="DOI"
                      hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" sm="12">
                  <span class="font-weight-bold py-2 subtitle-2">ABSTRACT</span>
                  <vue-editor v-model="itemModified.notes" />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="itemModified.authors"
                    label="Authors (Penulis)"
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                    <div class="caption font-weight-bold">
                      Upload File (PDF, Docx, etc)
                    </div>
                    <div class="blue lighten-4 rounded elevation-10 pa-4">
                      <v-btn
                          class="primary elevation-6 ma-1"
                          @click="showDialogUploadDocument()"
                          icon
                      >
                        <v-icon color="white">mdi-upload</v-icon>
                      </v-btn>
                      <span v-if="itemModified.fileName === ''"
                      >No File</span
                      >
                      <a
                          v-else
                          :href="`${downloadFile(itemModified.fileName)}`"
                          target="_blank"
                      >
                        {{ itemModified.fileName }}
                        <v-icon color="green" x-small>mdi-download</v-icon>
                      </a>
                    </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions class="pb-10 pr-16">
            <v-chip
              class="ml-4"
              color="error"
              outlined
              close
              small
              v-show="formDialogOptions.errorMessage"
            >
              {{ formDialogOptions.errorMessage }}
            </v-chip>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              outlined
              text
              @click="closeForm"
              class="hidden-sm-and-down"
            >
              Batal
            </v-btn>
            <v-btn
              color="blue darken-1"
              outlined
              text
              @click="save"
              :disabled="!valid || isItemModified === false"
              class="hidden-sm-and-down"
            >
              Simpan
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
      <UploadDocumentSimpleDialog
        ref="refUploadDialogDocument"
        @eventUploadSuccess="completeUploadSuccessDocument"
      ></UploadDocumentSimpleDialog>
      <UploadImageDialog
        ref="refUploadDialog"
        @eventUploadSuccess="completeUploadSuccess"
      ></UploadImageDialog>
      <close-confirm-dialog
        ref="refCloseConfirmDialog"
        @eventFromCloseConfirm="passingEventFromCloseConfirm"
      ></close-confirm-dialog>
      <v-snackbar v-model="snackbar">
        {{ snackBarMesage }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
        </template>
      </v-snackbar>
    </v-dialog>
  </div>
</template>
  
<script>
import FArticleService from "@/services/apiservices-library/f-article-service";
import UploadImageDialog from "@/components/utils/UploadImageDialog.vue";
import FileService from "@/services/apiservices/file-service";
import CloseConfirmDialog from "@/components/utils/CloseConfirmDialog.vue";
import FormMode from "@/models/form-mode";
import FArticle from "@/models/f-article";
import { format, parseISO } from "date-fns";
import {VueEditor} from "vue2-editor";
import UploadDocumentSimpleDialog from "@/components/utils/UploadDocumentSimpleDialog.vue";

export default {
  name: "FArticleDialog",
  components: {
    UploadDocumentSimpleDialog,
    CloseConfirmDialog,
    UploadImageDialog,
    VueEditor
  },
  props: {
    formMode: String,
  },
  data() {
    return {
      snackBarMesage: "",
      snackbar: false,
      dialogShow: false,
      formDialogOptions: {
        title1: "",
        title2: "",
        message1: "",
        message2: "",
        errorMessage: "",
        color: "grey lighten-3",
        width: 800,
        zIndex: 200,
        noconfirm: false,
      },
      itemsFCountry: [],
      itemsFArticleCateg: [],
      date: format(parseISO(new Date().toISOString()), "dd-MMM-yyyy"),
      menuDate: false,
      selectedItemIndex: -1,
      itemDefault: "",
      itemModified: new FArticle(0, "", ""),
      selectFDivision: { id: 0, kode1: "", description: "" },
      itemsFDivision: [
        { id: 1, kode1: "", description: "" },
        { id: 2, kode1: "", description: "" },
      ],
      newFArticleId: 0,
      transparent: "rgba(255, 255, 255, 0)",
      valid: false,
      rulesLenght: [
        (v) => !!v || " Tidak Boleh Kosong",
        (v) => v.length <= 255 || "Maksimal 255 Karakter",
        (v) => v.length > 1 || "Harus lebih besar dari 1 karakter",
      ],
      rulesNotEmtpy: [(v) => !!v || "Tidak boleh kosong"],
    };
  },
  computed: {
    publicationDate: {
      get() {
        try {
          const inputDate = new Date(this.itemModified.publicationDate);
          return inputDate.toISOString().split("T")[0];
        } catch (e) {
          return new Date().toISOString().split("T")[0];
        }
      },
      set(value) {
        this.itemModified.publicationDate = value;
      },
    },
    isItemModified() {
      const defaultItem = JSON.stringify(this.itemDefault);
      const modifiedItem = JSON.stringify(this.itemModified);
      return defaultItem !== modifiedItem;
    },
  },
  watch: {},
  methods: {
    showDialogUpload() {
      if (
        this.itemModified.kode1 !== undefined &&
        this.itemModified.description !== undefined &&
        this.itemModified.fdivisionBean !== undefined
      ) {
        if (this.itemModified.id === 0) {
          // this.$emit('eventSaveItemWithoutClose', false)
          this.saveCreateOnly();
        }
        this.$refs.refUploadDialog.showDialog();
      } else {
        this.snackBarMesage = "Kode, Deskripsi dan Divisi harus diisi dahulu";
        this.snackbar = true;
      }
    },
    completeUploadSuccess: function (val) {
      if (
        this.itemModified.avatarImage !== undefined &&
        this.itemModified.avatarImage !== ""
      ) {
        FileService.deleteImage(this.itemModified.avatarImage).then(
          () => {
          },
          (error) => {
            console.log(error.response);
          }
        );
      }
      if (val.fileName !== "") {
        this.$refs.refUploadDialog.closeDialog();
        this.itemModified.avatarImage = val.fileName;
        this.saveUpdateOnly();
      }
    },
    downloadFile(item) {
      // console.log(item);
      return FileService.file_url(item);
    },
    showDialogUploadDocument() {
      if (
          this.itemModified.kode1 !== "" &&
          this.itemModified.description !== "" &&
          this.itemModified.fdivisionBean !== 0
      ) {
        if (this.itemModified.id === 0) {
          this.saveCreateOnly();
        }
        this.$refs.refUploadDialogDocument.showDialog();
      } else {
        this.snackBarMesage =
            "Kode, Deskripsi, Divisi harus diisi dahulu";
        this.snackbar = true;
      }
    },

    completeUploadSuccessDocument: function (val) {
        if (
            this.itemModified.fileName !== undefined &&
            this.itemModified.fileName !== ""
        ) {
          FileService.deleteFile(this.itemModified.fileName).then(
              () => {
                console.log(`Delete Image ${this.itemModified.fileName}`);
              },
              (error) => {
                console.log(error.response);
              }
          );
        }

        if (val.fileName !== "") {
          this.$refs.refUploadDialogDocument.closeDialog();
          this.itemModified.fileName = val.fileName;
          this.itemModified.fileType = 'DOC';
          this.saveUpdateOnly();
        }
    },
    computedDateFormattedDatefns(value) {
      return value ? format(parseISO(value), "dd MMMM yyyy") : "";
    },
    showDialog(selectedIndex, item, itemsFDivision, itemsFCountry, itemsFArticleCateg) {
      this.dialogShow = !this.dialogShow;
      if (selectedIndex > -1) {
        this.selectedIndex = selectedIndex;
        this.initializeEditMode(item);
      } else {
        (this.itemDefault = new FArticle(0, "", "")),
          (this.itemModified = new FArticle(0, "", "")),
          (this.selectedIndex = -1);
      }

      this.itemsFDivision = itemsFDivision;
      this.itemsFCountry = itemsFCountry;
      this.itemsFArticleCateg = itemsFArticleCateg;
    },
    setDialogState(value) {
      this.dialogShow = value;
    },
    saveCreateOnly() {
      if (this.formMode === FormMode.NEW_FORM) {
        FArticleService.createFArticle(this.itemModified).then(
          (response) => {
            /**
             * dipaksa Save dan Update Dahulu
             */
            this.$emit("update:formMode", FormMode.EDIT_FORM);
            this.itemModified.id = response.data.id;
          },
          (error) => {
            this.formDialogOptions.errorMessage = error.response.data.message;
          }
        );
      }
    },
    save() {
      if (this.isItemModified === false) {
        //Close aja
        this.dialogShow = false;
        this.$emit("eventFromFormDialog1", this.itemModified);
        return;
      }
      if (this.$refs.form.validate()) {
        if (this.formMode === FormMode.EDIT_FORM) {
          FArticleService.updateFArticle(this.itemModified).then(
            () => {
              this.$emit("eventFromFormDialogEdit", this.itemModified);
            },
            (error) => {
              console.log(error);
              this.formDialogOptions.errorMessage = error.response.data.message;
            }
          );
        } else {
          FArticleService.createFArticle(this.itemModified).then(
            (response) => {
              this.$emit("eventFromFormDialogNew", response.data);
            },
            (error) => {
              console.log(error);
              this.formDialogOptions.errorMessage = error.response.data.message;
            }
          );
        }
      }
    },
    saveUpdateOnly() {
      FArticleService.updateFArticle(this.itemModified).then(
        () => {
        },
        (error) => {
          this.formDialogOptions.errorMessage = error.response.data.message;
        }
      );
    },
    closeForm() {
      if (!this.isItemModified) {
        this.dialogShow = false;
        this.$emit("eventFromFormDialog1", this.itemModified);
      } else {
        this.$refs.refCloseConfirmDialog.showDialog(
          " Sudah terdapat modifikasi data",
          "Tetap tutup dan reset perubahan?"
        );
      }
    },
    lookupImageUrl(item) {
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return require("@/assets/images/no_image_available.jpeg");
      } else {
        return FileService.image_url_medium(item.avatarImage);
      }
    },
    lookupImageUrlLazy(item) {
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return require("@/assets/images/no_image_available.jpeg");
      } else {
        return FileService.image_url_verylow(item.avatarImage);
      }
    },

    passingEventFromCloseConfirm(value) {
      if (value === "OKE") this.dialogShow = false;
    },
    initializeEditMode(item) {
      this.formDialogOptions.errorMessage = "";

      FArticleService.getFArticleById(item.id).then(
        (response) => {
          this.itemDefault = Object.assign({}, response.data);
          this.itemModified = response.data;
        },
        (error) => {
          console.log(error);
        }
      );
    },
  },
};
</script>
  
<style scoped>
.card-hover-opacity {
  opacity: 0.4;
}
.card-not-hover-opacity {
  opacity: 1;
  transition: opacity 0.4s ease-in-out;
}

.show-btns {
  color: blue !important;
  opacity: 1;
}
</style>